export default "__VITE_ASSET__e54442a0__"